import { dataTag } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTag = /*#__PURE__*/createIcon(dataTag)
export default IconTag
